import { NavLink } from 'react-router-dom'
import { MoreHorizontal } from 'lucide-react'
import { NAV_ITEMS, type MobileNavItem } from '../../types/navigation'
import { useTheme } from '../../hooks/useTheme'

interface MobileBottomNavProps {
  moreItems: MobileNavItem[]
  isMoreActive: boolean
  getBadgeCount: (route: string) => number | null
  onMoreClick: () => void
}

export default function MobileBottomNav({ moreItems, isMoreActive, getBadgeCount, onMoreClick }: MobileBottomNavProps) {
  const { resolvedTheme } = useTheme()
  const inactiveColour = resolvedTheme === 'dark' ? '#ffffff' : '#000000'

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-20 lg:hidden"
      style={{ background: 'var(--bg-card)', borderTop: '1px solid var(--border-color)', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex">
        {NAV_ITEMS.mobile.map(({ to, icon, label }) => {
          const badgeCount = getBadgeCount(to)
          return (
            <NavLink
              key={to}
              to={to}
              className="relative flex-1 flex flex-col items-center py-2.5 text-xs transition active:scale-95"
              style={({ isActive }) => ({
                color: isActive ? 'var(--color-accent)' : inactiveColour,
                fontWeight: isActive ? 600 : 400,
              })}
            >
              <span className="mb-0.5 flex items-center justify-center text-lg">{icon}</span>
              {label}
              {badgeCount !== null && badgeCount > 0 && (
                <span
                  className="absolute top-1.5 right-1/2 translate-x-4"
                  style={{ width: 7, height: 7, borderRadius: '50%', backgroundColor: 'var(--color-accent)' }}
                />
              )}
            </NavLink>
          )
        })}
        <button
          onClick={onMoreClick}
          className="relative flex-1 flex flex-col items-center py-2.5 text-xs transition active:scale-95"
          style={{
            color: isMoreActive ? 'var(--color-accent)' : inactiveColour,
            fontWeight: isMoreActive ? 600 : 400,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <span className="mb-0.5 flex items-center justify-center" style={{ height: '1.75rem' }}><MoreHorizontal className="w-6 h-6" /></span>
          More
          {moreItems.some(item => { const c = getBadgeCount(item.to); return c !== null && c > 0 }) && (
            <span
              className="absolute top-1.5 right-1/2 translate-x-3.5"
              style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: 'var(--color-accent)' }}
            />
          )}
        </button>
      </div>
    </nav>
  )
}
